import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Spin extends React.Component {
  static propTypes = {
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    thickness: PropTypes.number,
    color: PropTypes.string,
    fallbackLabel: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    size: '100%',
    thickness: 3,
    color: undefined,
    fallbackLabel: undefined,
    className: undefined,
  };

  render() {
    const { size, thickness, color, fallbackLabel, className } = this.props;

    return (
      <div className={clx('spin-outer', className)} style={{ width: size, paddingBottom: size }}>
        <div className={styles['spin-inner']}>
          {fallbackLabel && (
            <div className={styles['fallback-wrapper']}>
              <div className={styles['fallback-label']}>{fallbackLabel}</div>
            </div>
          )}
          <div className={styles['spin']} style={{ borderWidth: thickness, borderColor: color }} />
        </div>
      </div>
    );
  }
}
